function initModal() {
  [...document.querySelectorAll('.popwraps')].forEach((content) => {
    const modalActive = document.querySelector('body');
    const modalHolder = content.querySelector('.modal-holder');
    const overlay = content.querySelector('.overlay');
    const openModalBtn = content.querySelector('a[href="#"]');

    if (!openModalBtn) return;

    const openModal = function () {
      modalHolder.classList.remove('hidden');
      modalActive.classList.add('modal-active');
    };

    const closeModal = function () {
      modalHolder.classList.add('hidden');
      modalActive.classList.remove('modal-active');
    };

    openModalBtn.addEventListener('click', function (event) {
      event.preventDefault();

      openModal();
    });

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        closeModal();
      }
    });
  });
}
$(function() {
initModal();
});